export const WHEN_TO_USE = `Open a requested view.

Use this command when the user asks to:
- open or switch to a view;

Do not use this command to change settings of a view; use changeViewSettings
for that.

Match the user's words to a display name in 'viewNames' exactly. Each name is a
distinct view: 'Block Diagram' and 'Interactive Blocks' are different views,
and so are 'Relationships' and 'Dependency Map'. Never open one in place of
another because they sound alike or show similar data.

Put the user's own words for the view in 'requestedView' first, then choose
'view'; the command rejects a view that does not match those words.

If the requested view is not in 'viewNames', respond with view: 'unsupported'
rather than choosing the nearest view. This includes every view named in
'unavailableViews'.`;

export const CHANGE_VIEW_CONTEXT_DESCRIPTION = `'currentView' — the enum id of the
currently open view, or null if no view is open.

'viewNames' — maps each view id to its human-readable display name ('modernizedBlockDiagram' → 'Block Diagram'). A view can be
opened only when its id is present in this map. Match the user's words to the
display name, not to the id.

'unavailableViews' — display names of views that exist in Ardoq but cannot be
opened right now. When the user's words match one of these names, the request
is unsupported: never open a similar-sounding view from 'viewNames' instead.
`;
